import { defineMessages } from 'react-intl';

export const CatalogActions = Object.freeze({
  CATALOG_GET_DETAILS: 'CATALOG_GET_DETAILS',
  CATALOG_GET_FULLLYRICS: 'CATALOG_GET_FULLLYRICS',
  CATALOG_GET_ARTIST_DISCOGRAPHY: 'CATALOG_GET_ARTIST_DISCOGRAPHY',
  CATALOG_GET_ARTIST_EVENTS: 'CATALOG_GET_ARTIST_EVENTS',
  CATALOG_GET_ALL_ARTIST_TRACKS: 'CATALOG_GET_ALL_ARTIST_TRACKS',
  CATALOG_SET_CURRENT_SOURCE_ID: 'CATALOG_SET_CURRENT_SOURCE_ID',
  CATALOG_ANNOTATE_IDS: 'CATALOG_ANNOTATE_IDS',
  CATALOG_ANNOTATE_OBJECTS_SIMPLE: 'CATALOG_ANNOTATE_OBJECTS_SIMPLE',
  CATALOG_REFRESH_ANNOTATIONS: 'CATALOG_REFRESH_ANNOTATIONS',
  CATALOG_SET_PLAYLISTS: 'CATALOG_SET_PLAYLISTS',
} as const);

export const CatalogKeys = Object.freeze({
  CATALOG: 'catalog',
  TRACK_DETAILS: 'trackDetails',
  ARTIST_DETAILS: 'artistDetails',
  DETAILS: 'details',
  ANNOTATIONS: 'annotations',
  CURRENT_SOURCE_ID: 'currentSourceId',
  DISCOGRAPHY: 'discography',
  TRACKS: 'tracks',
  EVENTS: 'events',
} as const);

export const SourceTypeUrlParams = Object.freeze({
  STATION: 'station',
  STATION_THUMBS: 'station-thumbs',
  SONG: 'song',
  ALBUM: 'album',
  PLAYLIST: 'playlist',
  TOP_SONGS: 'top-songs',
  ARTIST: 'artist',
  MY_MUSIC: 'my-music',
  ALL_SONGS: 'all-songs',
  THUMBED_UP: 'thumbed-up',
  PODCAST: 'podcast',
} as const);

export const MY_THUMBS_UP_PLAYLIST = 'MyThumbsUp';

export const messages = defineMessages({
  radioOnlyPlaylist: {
    id: 't.radioOnlyPlaylist',
    defaultMessage: 'The songs on this playlist are only currently available for radio playback.',
  },
  unavailablePlaylist: {
    id: 't.unavailablePlaylist',
    defaultMessage: "The songs on this playlist aren't currently available for playback.",
  },
} as const);
